import {
  Store as VuexStore,
} from 'vuex';
import type {
  CommitOptions,
  DispatchOptions,
  Module,
} from 'vuex';

import { RootState } from '@/store/state';
import { initialSelectedProduct } from '@/utils/selectedProduct';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

import type { Actions } from './actions';
import type { Getters } from './getters';
import type { Mutations } from './mutations';
import type { State } from './state';

const state: State = {
  client: 'shared',
  clientEndpoint: '',
  darkMode: true,
  selectedProduct: initialSelectedProduct(),
  snackbars: [],
};

export type Store<S = State> = Omit<
  VuexStore<S>,
  'commit' | 'getters' | 'dispatch'
> & {
  commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(
    key: K,
    payload: P,
    options?: CommitOptions,
  ): ReturnType<Mutations[K]>;
} & {
  getters: {
    [K in keyof Getters]: ReturnType<Getters[K]>
  };
} & {
  dispatch<K extends keyof Actions>(
    key: K,
    payload: Parameters<Actions[K]>[1],
    options?: DispatchOptions,
  ): ReturnType<Actions[K]>;
};

export const AppStore: Module<State, RootState> = {
  state,
  mutations,
  actions,
  getters,
};
